import { render, staticRenderFns } from "./ConsultantPaymentDetails.vue?vue&type=template&id=a8d6929e&"
import script from "./ConsultantPaymentDetails.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConsultantPaymentDetails.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports